<div class="facet-filters-bar" *ngIf="!hidden">
    <sq-action-menu
        [items]="filters"
        [autoAdjust]="autoAdjust"
        [autoAdjustBreakpoint]="autoAdjustBreakpoint"
        [collapseBreakpoint]="collapseBreakpoint"
        [right]="rightAligned"
        [size]="size">
    </sq-action-menu>
</div>
